import React from 'react';
import { colors } from 'styleguide';

import { IconProps } from './types';

const LockClosed = ({ size = 20, color = colors('neutral', 2) }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.5 10.6923C5.5 9.31161 6.61929 8.19232 8 8.19232H11.2308C12.6115 8.19232 13.7308 9.31161 13.7308 10.6923V13C13.7308 14.3807 12.6115 15.5 11.2308 15.5H8C6.61929 15.5 5.5 14.3807 5.5 13V10.6923Z"
      fill={color}
      stroke={color}
    />
    <path
      d="M12.3846 8.61538V6.76923C12.3846 5.23983 11.1448 4 9.61539 4V4C8.08599 4 6.84616 5.23983 6.84616 6.76923V8.61538"
      stroke={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.96701 11.5468C10.215 11.4192 10.3847 11.1606 10.3847 10.8625C10.3847 10.4376 10.0403 10.0932 9.61545 10.0932C9.19062 10.0932 8.84622 10.4376 8.84622 10.8625C8.84622 11.1607 9.0159 11.4192 9.26397 11.5469L9.01313 12.6757C8.92749 13.061 9.22073 13.4266 9.61549 13.4266C10.0102 13.4266 10.3035 13.061 10.2179 12.6757L9.96701 11.5468Z"
      fill="#EDEFF3"
    />
  </svg>
);

export default LockClosed;
